import { TOGGLE_COLLAPSED_NAV, TOGGLE_MOBILE_NAV } from "../constants/Theme";

const initTheme = {
  navCollapsed: false,
  mobileNav: false,
};

const getInitialTheme = () => {
  try {
    const savedState = localStorage.getItem('redux_localstorage_simple');
    if (savedState) {
      const parsed = JSON.parse(savedState);
      if (parsed.theme) {
        return {
          ...initTheme,
          ...parsed.theme,
          navCollapsed: false,
        };
      }
    }
  } catch (e) {
    console.error('Error loading theme from localStorage:', e);
  }
  return initTheme;
};

const theme = (state = getInitialTheme(), action) => {
  switch (action.type) {
    case TOGGLE_COLLAPSED_NAV:
      return {
        ...state,
        navCollapsed: action.navCollapsed,
      };
    case TOGGLE_MOBILE_NAV:
      return {
        ...state,
        mobileNav: action.mobileNav,
      };
    default:
      return state;
  }
};

export default theme;
